
/* ===== VELANTIS_DROP20 — preventa se libera el día 20 de cada mes ===== */
(function(){
  var MESES=['enero','febrero','marzo','abril','mayo','junio','julio','agosto','septiembre','octubre','noviembre','diciembre'];
  var el=document.getElementById('preDrop'); if(!el) return;
  function cap(s){ return s.charAt(0).toUpperCase()+s.slice(1); }
  function mesNombre(m){ return MESES[((m%12)+12)%12]; }
  // Todas las preventas son del MES SIGUIENTE y se liberan el día 20.
  function state(){
    var now=new Date();
    var d=now.getDate(), m=now.getMonth(), y=now.getFullYear();
    var openPv, dropM, dropY;
    if(d>=20){
      // ya se liberó la preventa del mes siguiente; el próximo drop es el 20 del mes que viene (mes+2)
      openPv=m+1; dropM=m+1; dropY=y;
    }else{
      // vigente la preventa de este mes (liberada el 20 anterior); el próximo drop es el 20 de este mes (mes+1)
      openPv=m; dropM=m; dropY=y;
    }
    return {
      openMes: mesNombre(openPv),        // preventa actualmente abierta (mes siguiente al de su liberación)
      nextMes: mesNombre(openPv+1),      // la que se liberará en el próximo día 20
      dropMes: mesNombre(dropM),         // mes del próximo día 20
      target: new Date(dropY, dropM, 20, 0, 0, 0),
      dropToday: (d===20)
    };
  }
  function two(n){ return (n<10?'0':'')+n; }
  function render(){
    var s=state();
    var diff=Math.max(0, s.target-new Date());
    var dd=Math.floor(diff/86400000), hh=Math.floor(diff%86400000/3600000), mm=Math.floor(diff%3600000/60000), ss=Math.floor(diff%60000/1000);
    var cd='<div class="pre-cd">'+
        '<div class="pre-cd-unit"><div class="pre-cd-n">'+two(dd)+'</div><div class="pre-cd-l">días</div></div>'+
        '<div class="pre-cd-unit"><div class="pre-cd-n">'+two(hh)+'</div><div class="pre-cd-l">hrs</div></div>'+
        '<div class="pre-cd-unit"><div class="pre-cd-n">'+two(mm)+'</div><div class="pre-cd-l">min</div></div>'+
        '<div class="pre-cd-unit"><div class="pre-cd-n">'+two(ss)+'</div><div class="pre-cd-l">seg</div></div>'+
      '</div>';
    el.hidden=false; el.classList.add('open');
    if(s.dropToday){
      el.innerHTML='<div class="pre-drop-ic">🎉</div>'+
        '<div class="pre-drop-main"><span class="pre-drop-badge">Liberada hoy</span>'+
        '<p class="pre-drop-txt"><b>Preventa de '+cap(s.openMes)+' liberada hoy.</b> Reserva los lanzamientos del mes siguiente antes de su llegada oficial.</p>'+
        '<p class="pre-drop-sub">Cada día 20 liberamos la preventa del mes siguiente.</p></div>'+cd;
    }else{
      el.innerHTML='<div class="pre-drop-ic">🔓</div>'+
        '<div class="pre-drop-main"><span class="pre-drop-badge">Preventa abierta</span>'+
        '<p class="pre-drop-txt"><b>Preventa de '+cap(s.openMes)+' abierta.</b> Reserva los lanzamientos del mes siguiente antes de su llegada oficial.</p>'+
        '<p class="pre-drop-sub">Próxima preventa (de '+cap(s.nextMes)+') el 20 de '+s.dropMes+'.</p></div>'+cd;
    }
  }
  render(); setInterval(render, 1000);
})();
